import { Loader2 } from 'lucide-react';

/**
 * Loading — full-width vertically-padded block that centers the spinner.
 *
 * Previously used `min-h-screen` which made it 100vh and shifted off-center
 * when rendered inside AdminLayout's main pane (the sidebar offsets the
 * available width, so a viewport-anchored centerline looked left-leaning).
 * `w-full` + vertical padding keeps it centered to the parent regardless of
 * sidebar / mobile drawer state.
 */
export function Loading() {
  return (
    <div className="w-full py-24 flex items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="w-8 h-8 animate-spin text-brand-600" />
        <p className="text-sm text-gray-600">กำลังโหลด...</p>
      </div>
    </div>
  );
}
